import { updatePreferences } from 'store/slices/userDetailsSlice';
import { Button, Typography, Box } from '@mui/material';
import { LIGHT_GREY_2 } from 'utilities/colors';
import { getUpdatedColorLegend } from 'components/ImageViewer/SlideViewerHeader/utils';

export const ColorLegendButtons = ({
  colorLegend,
  preferences,
  dispatch,
  uuid,
  classes,
}) => {
  const legend = colorLegend[uuid];

  if (!legend) return null;

  const handleColorClick = (color) => {
    const updatedPreferences = getUpdatedColorLegend(preferences, uuid, color);

    dispatch(updatePreferences(updatedPreferences));
  };

  return (
    <>
      {Object.keys(legend).map((color) => {
        const backgroundColor = legend[color].isSelected ? color : LIGHT_GREY_2;

        return (
          <Box key={color} className={classes.colorLegendButtons}>
            <Button
              onClick={() => handleColorClick(color)}
              sx={{
                backgroundColor,
                '&:hover': {
                  backgroundColor,
                },
              }}
              className={classes.colorButton}
            />
            <Typography fontFamily="Courier">{legend[color].label}</Typography>
          </Box>
        );
      })}
    </>
  );
};
